import { render } from "./App.vue?vue&type=template&id=3236316d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3236316d&lang=css"

import exportComponent from "/Users/ashrock_m13/Ashrockzzz/virtual-lab/virtuallab-networksecurity/exp-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__